/**
 * @desc: 文件描述
 * @author: zengtiansheng
 * @update: 2018/3/17
 */
import Vue from 'vue'
import transferAccRemind from './transferAccRemind'
import qtbaoApiTransferAccRemind from './qtbaoApiTransferAccRemind'
const getAnInstance = function (options, component) {
  const Component = Vue.extend(component)
  const instance = new Component({
    el: document.createElement('div'),
    data: options || {}
  })
  instance.vm = instance.$mount()
  return instance
}
const getComponent = function (options, component) {
  const instance = getAnInstance(options, component)
  Vue.nextTick(function () {
    document.body.appendChild(instance.vm.$el)
  })
}
export const dialogTranAccRemind = (options) => { getComponent(options, transferAccRemind) }
export const dialogQtbaoApiTranAccRemind = (options) => { getComponent(options, qtbaoApiTransferAccRemind) }



// WEBPACK FOOTER //
// ./src/components/dialog/index.js